import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import React, {useEffect, useRef, useState} from "react";
import {Paper} from "@mui/material";
import {api} from "../../services/apiService";


export default function Clients() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalClients, setTotalClients] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [search, setSearch] = useState('');
  const debounceRef = useRef(null);

  const columns = [
    {
      field: "isCompany",
      headerName: "Type",
      width: 130,
      valueFormatter: (params) => params ? "Professionnel" : "Particulier"
    },     // width fixe ok ici
    {field: "name", headerName: "Nom", flex: 1, minWidth: 150},
    {field: "email", headerName: "Email", flex: 1, minWidth: 200},
    {field: "phone", headerName: "Téléphone", flex: 1, minWidth: 150},
  ];

  useEffect(() => {
    setLoaded(false);
    const params = new URLSearchParams({
      page: paginationModel.page + 1,
      per_page: paginationModel.pageSize,
      ...(search && {q: search}),
    });
    api.get(`/clients/list?${params}`)
      .then(response => {
        setClients(response.data.clients);
        setTotalClients(response.data.total);
        setLoaded(true);
      })
      .catch(error => {
        console.error("Error fetching clients:", error);
      });
  }, [paginationModel, search]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setPaginationModel(prev => ({...prev, page: 0}));
      setSearch(value);
    }, 400);
  };

  return (
    <Container>
      <Typography variant="h1">Clients</Typography>


      {/* Liste avec recherche + bouton */}
      <Grid container spacing={2} sx={{display: 'flex', justifyContent: 'space-between', mt: '2rem'}}>
        <TextField
          sx={{width: {xs: '100%', md: 'auto'}}}
          placeholder="Rechercher un client..."
          variant="outlined"
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon/>
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="contained"
          startIcon={<AddIcon/>}
          sx={{height: 'min-content', alignSelf: 'center', width: {xs: '100%', md: 'auto'}}}
          onClick={() => navigate("/clients/add")}
        >
          Nouveau client
        </Button>
      </Grid>

      <Paper sx={{height: 400, width: '100%', mt: '2rem'}}>
        <DataGrid
          rows={clients}
          columns={columns}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 25, 50]}
          paginationMode="server"
          rowCount={totalClients}
          loading={!loaded}
          onRowClick={(params) => navigate(`/clients/details/${params.id}`)}
          sx={{
            border: 0,
            cursor: "pointer",
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#f0f0f0",
            },
            backgroundColor: "#fff",
          }}
        />
      </Paper>
    </Container>
  )
}